export default __webpack_public_path__ + "static/media/google-1.2c28da16.svg";